import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'

// material-ui icons
import FiberManualRecord from '@material-ui/icons/FiberManualRecord'

// core components
import Table from 'components/Table/Table.jsx'

//import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx'
//import regularFormsStyle from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle'
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/signingPathInputTable.jsx'

// Dropdowns
import DropdownDepartments from '../Components/DropdownDepartments'
import DropdownUserGroups from '../Components/DropdownUserGroups'
import DropdownPositions from '../Components/DropdownPositions'

import { logger } from '../utility/utility'

class TypeOfLevelOfApprovers extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // need to make a ref here, otherwise it'll be undefined when it's called
      // actually this is unnecessary, can use it directly as it is
      // this renaming is more for comments
      returnValueToCaller: props.onClick
    }
    this.handleRadioClick = this.handleRadioClick.bind(this)
  }
  componentDidUpdate() {
    if (this.props.approverType !== this.state.approverType) {
      this.setState({
        approverType: this.props.approverType.toString() || '1'
      })
    }
  }
  handleRadioClick(event) {
    this.setState({
      approverType: event.target.value
    })
    // return to the caller
    this.props.onClick(event.target.value)
  }
  //<p>{this.state.approverType}</p>
  render() {
    //console.log(`Rendering with ${this.props.approverType}`)
    const { classes, key: index, disabled } = this.props
    return (
      <div id={`rows-${index}`}>
        <div className={classes.checkboxAndRadio + ' ' + classes.checkboxAndRadioHorizontal}>
          <FormControlLabel
            control={
              <Radio
                key='at1'
                disabled={disabled}
                checked={this.props.approverType.toString() === '1'}
                onChange={this.handleRadioClick}
                value='1'
                name='approverType'
                aria-label='A'
                icon={<FiberManualRecord className={classes.radioUnchecked} />}
                checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
                classes={{
                  checked: classes.radio,
                  root: classes.radioRoot
                }}
              />
            }
            classes={{
              label: classes.label
            }}
            label={'Reporting Manager of Previous Level'}
          />
        </div>
        <div className={classes.checkboxAndRadio + ' ' + classes.checkboxAndRadioHorizontal}>
          <FormControlLabel
            control={
              <Radio
                key='at2'
                disabled={disabled}
                checked={this.props.approverType.toString() === '2'}
                onChange={this.handleRadioClick}
                value='2'
                name='approverType'
                aria-label='B'
                icon={<FiberManualRecord className={classes.radioUnchecked} />}
                checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
                classes={{
                  checked: classes.radio,
                  root: classes.radioRoot
                }}
              />
            }
            classes={{
              label: classes.label
            }}
            label='Department'
          />
        </div>
        <div className={classes.checkboxAndRadio + ' ' + classes.checkboxAndRadioHorizontal}>
          <FormControlLabel
            control={
              <Radio
                key='at3'
                disabled={disabled}
                checked={this.props.approverType.toString() === '3'}
                onChange={this.handleRadioClick}
                value='3'
                name='approverType'
                aria-label='C'
                icon={<FiberManualRecord className={classes.radioUnchecked} />}
                checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
                classes={{
                  checked: classes.radio,
                  root: classes.radioRoot
                }}
              />
            }
            classes={{
              label: classes.label
            }}
            label='Group'
          />
        </div>
        <div className={classes.checkboxAndRadio + ' ' + classes.checkboxAndRadioHorizontal}>
          <FormControlLabel
            control={
              <Radio
                key='at4'
                disabled={disabled}
                checked={this.props.approverType.toString() === '4'}
                onChange={this.handleRadioClick}
                value='4'
                name='approverType'
                aria-label='D'
                icon={<FiberManualRecord className={classes.radioUnchecked} />}
                checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
                classes={{
                  checked: classes.radio,
                  root: classes.radioRoot
                }}
              />
            }
            classes={{
              label: classes.label
            }}
            label='Position'
          />
        </div>
      </div>
    )
  }
}

TypeOfLevelOfApprovers = withStyles(extendedTablesStyle)(TypeOfLevelOfApprovers)

class SigningPathInputTables extends React.Component {
  constructor(props) {
    super(props)

    // This becomes stateless, it follows the props instead of state
    const { getLevelData } = this.props
    this.state = {
      returnLevelData: getLevelData
    }
  }

  render() {
    // console.log(this.props)
    const { classes } = this.props
    const { data, numberOfLevels: levels, companyId, isDisabled } = this.props
    const numberOfLevels = (data && data.length) || levels

    let displayData = []
    let workingData = []
    displayData.push([0, 'Applicant', 'N/A', ''])

    //there will be always data since data will be initialized in DidMount
    if (!data) {
      let initialData = []
      for (let i = 1; i < numberOfLevels; i++) {
        initialData.push({
          level: i,
          approverType: 1,
          approverGroupId: '',
          persons: ''
        })
      }
      workingData = initialData
    } else {
      workingData = data
    }
    const approvers = (value, key) => {
      // console.log(value, key)
      switch (value.approverType) {
        case '1':
          return `Applicant's Manager`

        case '2':
          return (
            <DropdownDepartments
              labelText='Department'
              id='approverGroupId'
              isDisabled={isDisabled}
              key={`approverGroupId+${key}`}
              companyId={companyId}
              order={key}
              formControlProps={{
                fullWidth: true
              }}
              value={value.approverGroupName}
              onChange={v => this.state.returnLevelData('approverGroup', key, v)}
            />
          )

        case '3':
          return (
            <DropdownUserGroups
              labelText='User Groups'
              id='approverGroupId'
              isDisabled={isDisabled}
              key={`approverGroupId+${key}`}
              companyId={companyId}
              order={key}
              formControlProps={{
                fullWidth: true
              }}
              value={value.approverGroupName}
              onChange={v => this.state.returnLevelData('approverGroup', key, v)}
            />
          )

        case '4':
          return (
            <DropdownPositions
              labelText='Positions'
              id='positionId'
              isDisabled={isDisabled}
              key={`approverGroupId+${key}`}
              companyId={companyId}
              order={key}
              formControlProps={{
                fullWidth: true
              }}
              value={value.approverGroupName}
              onChange={v => this.state.returnLevelData('approverGroup', key, v)}
            />
          )
        default:
          logger('SigningPathInputTable: render:', `invlid approver type ${value.approverType}`, true)
      }
    }
    workingData.map((value, key) => {
      return displayData.push([
        value.level,
        <TypeOfLevelOfApprovers
          approverType={value.approverType}
          key={key}
          disabled={isDisabled}
          onClick={v => this.state.returnLevelData('approverType', key, v)}
        />,
        approvers(value, key)
      ])
    })
    return (
      <Table
        tableHead={['Level', 'Signer Type', 'Signer Designation', '']}
        tableData={displayData} //{this.state.displayData}
        tableShopping
        customHeadCellClasses={[classes.left, classes.left, classes.left]}
        customHeadClassesForCells={[0, 1, 2]}
        customCellClasses={[classes.customFont, classes.customFont, classes.customFont]}
        customClassesForCells={[0, 1, 2]}
      />
    )
  }
}
//'SIGNER COMPANY',
export default withStyles(extendedTablesStyle)(SigningPathInputTables)
